import { Injectable } from "@angular/core";
import { SecurityApiService } from "@senior-gestao-pessoas/angular-components";
import { PermissionResourcesAppointmentLed, PermissionResourcesAppointmentManager, PermissionResourcesAppointmentMy } from "../../modules/appointment/utils/appointment-permission-resources";
import { PermissionResourcesCareerLed, PermissionResourcesCareerManager, PermissionResourcesCareerMy } from "../../modules/career/utils/career-permission-resources";
import { PermissionResourcesCorporateWallMy } from "../../modules/corporate-wall/utils/corporate-wall-permission-resources";
import { PermissionResourcesMoodsManager } from "../../modules/moods/utils/moods-permission-resources";
import { PermissionResourcesMyTeamManager, PermissionResourcesMyTeamManagerFeature, PermissionResourcesMyTeamManagerLed, PermissionResourcesMyTeamManagerAppointment, PermissionResourcesMyTeamMy, PermissionResourcesMyTeamManagerCareer } from "../../modules/my-team/utils/team-permission-resources";
import { PermissionResourcesPayRollManager, PermissionResourcesPayRollMy } from "../../modules/payroll/utils/payroll-permission-resources";
import { PermissionResourcesPerformanceLed, PermissionResourcesPerformanceManager, PermissionResourcesPerformanceMy } from "../../modules/performance/utils/performance-permission-resources";
import { PermissionResourcesRecruitmentManager, PermissionResourcesRecruitmentMy } from "../../modules/recruitment/utils/recruitment-permission-resources";
import { PermissionResourcesRemunerationLed, PermissionResourcesRemunerationManager, remunerationSpecialPermissions } from "../../modules/remuneration/utils/remuneration-permission-resources";
import {
	PermissionResourcesSSTManager,
} from "../../modules/sst/utils/sst-permission-resources";
import { AnalyticType, ModuleType, SectionModuleType } from "../common/enums";
import { PermissionTypeEnum } from "../permission/PermissionTypeEnum";
import { PermissionResourcesCore, PermissionResourcesModules } from "../utils/core-permission-resources";

export interface PermissionResourcePayload {
	resource: string;
	actions: PermissionTypeEnum[];
}
@Injectable({
	providedIn: "root"
})
export class PermissionResourceService {

	private modulesPermission = [];
	private readonly resourcesArray = Object.values(
		Object.assign(
			PermissionResourcesCore,
			PermissionResourcesModules,
			PermissionResourcesAppointmentLed,
			PermissionResourcesAppointmentManager,
			PermissionResourcesAppointmentMy,
			PermissionResourcesCareerLed,
			PermissionResourcesCareerManager,
			PermissionResourcesCareerMy,
			PermissionResourcesCorporateWallMy,
			PermissionResourcesMoodsManager,
			PermissionResourcesMyTeamManager,
			PermissionResourcesMyTeamManagerAppointment,
			PermissionResourcesMyTeamManagerCareer,
			PermissionResourcesMyTeamMy,
			PermissionResourcesSSTManager,
			PermissionResourcesPayRollManager,
			PermissionResourcesPayRollMy,
			PermissionResourcesPerformanceLed,
			PermissionResourcesPerformanceManager,
			PermissionResourcesPerformanceMy,
			PermissionResourcesRecruitmentManager,
			PermissionResourcesRecruitmentMy,
			PermissionResourcesRemunerationLed,
			PermissionResourcesRemunerationManager
		)
	);

	constructor(private securityApiService: SecurityApiService) {
		this.initializationData();
		this.loadingManagerPermission();
		this.loadingMyPermission();
		this.loadingLedPermission();
	}

	private initializationData() {
		Object.keys(ModuleType).forEach(type => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + type] = [];
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.APPOINTMENT] = [];
			this.modulesPermission[AnalyticType.MY + "|" + type] = [];
			this.modulesPermission[AnalyticType.LED + "|" + type] = [];
		});

		// registro de subseções
		this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.TEAM + "|" + SectionModuleType.LED] = [];
		this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.TEAM + "|" + SectionModuleType.FEATURES] = [];
		this.modulesPermission[AnalyticType.MY + "|" + ModuleType.TEAM + "|" + SectionModuleType.LED] = [];
	}

	public hasPermissionModule(analyticType: AnalyticType, module: ModuleType, section: SectionModuleType = null): boolean {
		const sectionKey = section != null ? "|" + section : "";
		return this.securityApiService.areAnyVisibleStatic(this.modulesPermission[analyticType + "|" + module + sectionKey]);
	}

	private loadingLedPermission() {
		Object.keys(PermissionResourcesAppointmentLed).forEach(val => {
			this.modulesPermission[AnalyticType.LED + "|" + ModuleType.APPOINTMENT].push(this.getResourceObject(PermissionResourcesAppointmentLed[val]));
		});

		Object.keys(PermissionResourcesPerformanceLed).forEach(val => {
			this.modulesPermission[AnalyticType.LED + "|" + ModuleType.PERFORMANCE].push(this.getResourceObject(PermissionResourcesPerformanceLed[val]));
		});

		Object.keys(PermissionResourcesCareerLed).forEach(val => {
			this.modulesPermission[AnalyticType.LED + "|" + ModuleType.CAREER].push(this.getResourceObject(PermissionResourcesCareerLed[val]));
		});

		Object.keys(PermissionResourcesRemunerationLed).forEach(val => {
			this.modulesPermission[AnalyticType.LED + "|" + ModuleType.REMUNERATION].push(this.getResourceObject(PermissionResourcesRemunerationLed[val]));
		});
	}

	private loadingMyPermission() {
		Object.keys(PermissionResourcesMyTeamMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.TEAM].push(this.getResourceObject(PermissionResourcesMyTeamMy[val]));
		});
		Object.keys(PermissionResourcesMyTeamMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.TEAM + "|" + SectionModuleType.LED].push(this.getResourceObject(PermissionResourcesMyTeamMy[val]));
		});

		Object.keys(PermissionResourcesAppointmentMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.APPOINTMENT].push(this.getResourceObject(PermissionResourcesAppointmentMy[val]));
		});

		Object.keys(PermissionResourcesPayRollMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.PAYROLL].push(this.getResourceObject(PermissionResourcesPayRollMy[val]));
		});

		Object.keys(PermissionResourcesPerformanceMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.PERFORMANCE].push(this.getResourceObject(PermissionResourcesPerformanceMy[val]));
		});

		Object.keys(PermissionResourcesCareerMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.CAREER].push(this.getResourceObject(PermissionResourcesCareerMy[val]));
		});

		// não existe
		Object.keys(PermissionResourcesRecruitmentMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.RECRUITMENT].push(this.getResourceObject(PermissionResourcesRecruitmentMy[val]));
		});

		Object.keys(PermissionResourcesCorporateWallMy).forEach(val => {
			this.modulesPermission[AnalyticType.MY + "|" + ModuleType.CORPORATE_WALL].push(this.getResourceObject(PermissionResourcesCorporateWallMy[val]));
		});
	}

	private loadingManagerPermission() {
		Object.keys(PermissionResourcesMyTeamManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.TEAM].push(this.getResourceObject(PermissionResourcesMyTeamManager[val]));
		});

		Object.keys(PermissionResourcesMyTeamManagerLed).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.TEAM + "|" + SectionModuleType.LED].push(this.getResourceObject(PermissionResourcesMyTeamManagerLed[val]));
		});

		Object.keys(PermissionResourcesMyTeamManagerFeature).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.TEAM + "|" + SectionModuleType.FEATURES].push(this.getResourceObject(PermissionResourcesMyTeamManagerFeature[val]));
		});

		Object.keys(PermissionResourcesMyTeamManagerCareer).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.TEAM + "|" + SectionModuleType.FEATURES].push(this.getResourceObject(PermissionResourcesMyTeamManagerCareer[val]));
		});

		Object.keys(PermissionResourcesAppointmentManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.APPOINTMENT].push(this.getResourceObject(PermissionResourcesAppointmentManager[val]));
		});

		Object.keys(PermissionResourcesMyTeamManagerAppointment).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.APPOINTMENT].push(this.getResourceObject(PermissionResourcesMyTeamManagerAppointment[val]));
		});

		Object.keys(PermissionResourcesPayRollManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.PAYROLL].push(this.getResourceObject(PermissionResourcesPayRollManager[val]));
		});

		Object.keys(PermissionResourcesSSTManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.SST].push(this.getResourceObject(PermissionResourcesSSTManager[val]));
		});

		Object.keys(PermissionResourcesPerformanceManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.PERFORMANCE].push(this.getResourceObject(PermissionResourcesPerformanceManager[val]));
		});

		Object.keys(PermissionResourcesCareerManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.CAREER].push(this.getResourceObject(PermissionResourcesCareerManager[val]));
		});

		Object.keys(PermissionResourcesRecruitmentManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.RECRUITMENT].push(this.getResourceObject(PermissionResourcesRecruitmentManager[val]));
		});

		Object.keys(PermissionResourcesRemunerationManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.REMUNERATION].push(this.getResourceObject(PermissionResourcesRemunerationManager[val]));
		});
		const specialPermissions = remunerationSpecialPermissions();
		specialPermissions.forEach(specPerm => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.REMUNERATION].find(perm => perm.resource === specPerm.resource).actions = specPerm.actions;
		});

		Object.keys(PermissionResourcesMoodsManager).forEach(val => {
			this.modulesPermission[AnalyticType.MANAGER + "|" + ModuleType.MOODS].push(this.getResourceObject(PermissionResourcesMoodsManager[val]));
		});

	}

	private getResourceObject(resource: string): any {
		return {resource};
	}

	/**
	 * Carrega os recursos habilitados para o usuário e verifica se o mesmo possui permissão para a tela acessada.
	 *
	 * @param permissionResource Recurso a ser validado.
	 * @returns Retorno booleano indicando se o usuário possui permissão para o recurso.
	 */
	async canActivate(permissionResource: PermissionResourcesCore): Promise<boolean> {
		await this.securityApiService.loadPermissions(this.getResourcesPayload()).toPromise();
		if (permissionResource) {
			return this.securityApiService.isVisibleStatic(permissionResource);
		}

		return !permissionResource;
	}

	/**
	 * Retorna o payload de envio para a primitiva checkAccess.
	 *
	 * @returns Payload com o array dos recursos e suas respectivas ações.
	 */
	public getResourcesPayload() {
		const allPermissionsModule = this.mapPermissions();
		let specificPermissions = remunerationSpecialPermissions();
		if (!specificPermissions) {
			specificPermissions = [];
		}

		specificPermissions.forEach(specialPerm => {
			allPermissionsModule.forEach(permission => {
				if (permission.resource === specialPerm.resource) {
					permission.actions = specialPerm.actions;
				}
			});
		});

		return allPermissionsModule;
	}

	/**
	 * Realiza o parse do array de recursos para o payload de envio.
	 *
	 * @returns Payload com o array dos recursos
	 */
	private mapPermissions(): any[] {
		const permissionsPayloadArray = [];
		this.resourcesArray.forEach(resource => {
			permissionsPayloadArray.push({
				resource: resource
			});
		});
		return permissionsPayloadArray;
	}
}
